import { FC, memo, useMemo } from 'react';

import { CommonFlowCard, CommonFlowCardProps } from '@/lib/v3/components';

import { GroupsManageContactData } from '@/modules/AutomationModuleNew/types/flowsTypes';

interface GroupManageContactCardProps extends CommonFlowCardProps {
  data: GroupsManageContactData;
}

const GroupManageContactCard: FC<GroupManageContactCardProps> = (props) => {
  const { data } = props;
  const { input } = data;

  const info = useMemo(() => {
    const { addGroupIds, removeGroupIds } = input;
    if (addGroupIds?.length === 0 && removeGroupIds.length === 0) return undefined;
    return `Number of groups: ${addGroupIds.length + removeGroupIds.length}`;
  }, [input]);

  return <CommonFlowCard {...props} info={info} />;
};

export default memo(GroupManageContactCard);
